
import { lazy, LazyExoticComponent, ReactNode } from 'react';

export interface RouteConfig {
  path: string;
  exact: boolean;
  component: LazyExoticComponent<React.ComponentType<any>> | ReactNode| any;
}
// front end pages
const Homepage = lazy(() => import('../views/pages/frontend-pages/Homepage'));
 
const About = lazy(() => import('../views/pages/frontend-pages/About'));
const JourneyView = lazy(() => import('../views/pages/frontend-pages/JourneyView'));
const ModuleView = lazy(() => import('../views/pages/frontend-pages/ModuleView'));
const Features = lazy(() => import('../views/pages/frontend-pages/Features'));
const  Catalogue = lazy(() => import('../views/pages/frontend-pages/Catalogue'));
const Contact = lazy(() => import('../views/pages/frontend-pages/Contact'));
const AccountSetting = lazy(() => import('../views/pages/account-setting/AccountSetting'));
 
const routesObj: RouteConfig[] = [

///********frontend****** */
  {
    path: "/",
    exact: true,
    component: lazy(() =>  import('../views/pages/frontend-pages/Homepage')),
  },
  {
    path: "/home",
    exact: true,
    component: lazy(() =>  import('../views/pages/frontend-pages/Homepage')),
  },
  {
    path: "/about",
    exact: true,
    component: lazy(() =>  import('../views/pages/frontend-pages/About')),
  },
  {
    path: "/journeyView/:id",
    exact: true,
    component: lazy(() =>  import('../views/pages/frontend-pages/JourneyView')),
  },
  {
    path: "/moduleView/:id",
    exact: true,
    component: lazy(() =>  import('../views/pages/frontend-pages/ModuleView')),
  },
  {
    path: "/features",
    exact: true,
    component: lazy(() =>  import('../views/pages/frontend-pages/Features')),
  },
  {
    path: "/catalogue",
    exact: true,
    component: lazy(() =>  import('../views/pages/frontend-pages/Catalogue')),
  },
  {
    path: "/contact",
    exact: true,
    component: lazy(() =>  import('../views/pages/frontend-pages/Contact')),
  },

  {
    path: "/termsofservice",
    exact: true, 
    component: lazy(() => import('../views/pages/frontend-pages/TermsOfService')),
  },
  {
    path: "/privacypolicy",
    exact: true, 
    component: lazy(() => import('../views/pages/frontend-pages/PrivacyPolicy')),
  },
 
///********Dashboard****** */
     {
    path: "/dashboard/login",
    exact: true, 
    component: lazy(() => import('../views/pages/frontend-pages/Login')),
  },
  {
    path: "/dashboard",
    exact: true,
    component: lazy(() => import('../pages/Main')),
  },
 
  {
    path: "/dashboard/courseModule/:learnJourneyId/:moduleId",
    exact: true,
    component: lazy(() => import('../modules/components/moduleMainContent')),
  },
 
  {
    path: "/dashboard/onboarding",
    exact: true, 
    component: lazy(() => import('../pages/onbouarding/stepperRoot')),
  },
  // {
  //   path: "/dashboard/onboarding/account",
  //   exact: true, 
  //   component: lazy(() => import('../pages/onbouarding/steps/account')),
  // },
  {
    path: "/dashboard/onboarding/interests",
    exact: true, 
    component: lazy(() => import('../pages/onbouarding/steps/interests')),
  },
  {
    path: "/dashboard/onboarding/RequiredSkillsStep",
    exact: true, 
    component: lazy(() => import('../pages/onbouarding/RequiredSkillsStep')),
  },
  {
    path: "/dashboard/onboarding/generator",
    exact: true, 
    component: lazy(() => import('../pages/onbouarding/generator')),
  },
  {
    path: "/dashboard/onboarding/skills",
    exact: true, 
    component: lazy(() => import('../pages/onbouarding/steps/skills')),
  },
  {
    path: "/dashboard/confirm",
    exact: true, 
    component: lazy(() => import('../pages/onbouarding/steps/confirm')),
  },
  {
    path: "/dashboard/onboarding/grouping",
    exact: true, 
    component: lazy(() => import('../pages/onbouarding/groupingPage')),
  },
  {
    path: "/dashboard/onboarding/interests",
    exact: true, 
    component: lazy(() => import('../pages/onbouarding/steps/interests')),
  },

  {
    path: "/dashboard/signup",
    exact: true,
    component: lazy(() => import('../pages/authentication/signUp')),
  },
  {
    path: "/dashboard/verif",
    exact: true,
    component: lazy(() => import('../pages/authentication/utils/verification')),
  },
  {
    path: "/dashboard/signupform",
    exact: true,
    component: lazy(() => import('../pages/authentication/signUpForm')),
  },
  {
    path: "/dashboard/profile",
    exact: true,
    component: lazy(() => import('../views/pages/account-setting/AccountSetting')),
    
  },
  {
    path: "/dashboard/achievement",
    exact: true,
    component: lazy(() => import('../views/pages/achievement/Achievement')),
    
  },
  {
    path: "/dashboard/community",
    exact: true,
    component: lazy(() => import('../views/pages/community/Community')),
    
  },
  {
    path: "/dashboard/curriculum",
    exact: true,
    component: lazy(() => import('../views/pages/curriculum/Curriculum')),
    
  },
  {
    path: "/dashboard/certificate",
    exact: true,
    component: lazy(() => import('../views/pages/achievement/CertificateGenerator')),
    
  },

 
  
   // Add the NotFound route as the catch-all route
  {
    path: "*",
    exact: false,
    component: lazy(() => import('../common/components/pageNotFound')),
  },

];

export default routesObj;


